// extracted by mini-css-extract-plugin
module.exports = {"centerBlock":"_2bypkthjo7-AGD5NqMCz_1","resumeButton":"_8d2Zm7T_-PllJueZ8ZZzh","quote":"wNSU2Rl-d1LrCJvhBK3VH","aboutMe":"_2SFZc9aQKjhRVDRMkLoebT"};